import React from "react";

const InfoCard = ({
  id,
  icon,
  title,
  shortDescription,
  longDescription,
  isExpanded,
  onToggle,
}) => {
  return (
    <div
      className={`bg-[#0e1b4a] rounded-2xl  p-6 transition-all duration-300 ease-in-out hover:scale-105 text-center border border-softGreen/30 group text-left flex flex-col ${
        isExpanded
          ? ""
          : "h-[280px] lg:h-[300px] md:h-[250px] xs:h-[250px] xxs:h-[240px]"
      }`}
    >
      <div className="mb-2">{icon}</div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-[#b8eae4] text-sm leading-relaxed">
        {shortDescription}
      </p>

      {isExpanded && longDescription && (
        <>
          <div className="my-[1rem]  h-[0.0625rem] relative w-[80%] m-auto gradient-divider"></div>
          <p
            className={`${
              isExpanded
                ? "max-h-[200px] text-[#b8eae4] overflow-y-auto custom-scrollbar"
                : "text-[#b8eae4] text-sm leading-relaxed mt-2"
            }`}
          >
            {longDescription}
          </p>
        </>
      )}

      <div className="mt-auto pt-4">
        {longDescription && (
          <button
            onClick={() => onToggle(id)}
            className="text-brandGreen h text-sm font-semibold"
          >
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        )}
      </div>
    </div>
  );
};

export default InfoCard;
